export const CONST_FETCH_PAGE_ERROR = 'An error occured while fetching data, please try again later';

export const CONST_USER_FETCH_TIMEOUT = 500;

export const CONST_AUTH = {
  SCHOOL_CREDS: 'school_creds',
  TOKEN_ID: 'token_id',
  SCHOOL_ID: 'school_id'
};
